import { Divider, Paper, Typography } from "@mui/material";
import { no_img } from "assets";
import { useFormatPrice } from "hooks";
import React from "react";

const ProdWidget = ({ value }) => {
  const formatPrice = useFormatPrice();
  const imageUrl = value?.imgUrl || no_img;
  const imageClass = `w-full h-[150px] border-b border-gray-200 rounded-t-[0.8rem] ${
    value?.imgUrl ? "object-cover" : "object-contain"
  }`;

  return (
    <Paper className="!rounded-[12px] cursor-pointer bg-white h-full transition-shadow hover:shadow-md">
      <img className={imageClass} src={imageUrl} alt="prod-img" />

      <Divider className="bg-gray-200" />

      <div className="px-3 py-2 space-y-1">
        <Typography
          variant="subtitle2"
          sx={{ fontSize: "13px" }}
          className="font-semibold text-gray-800 leading-tight line-clamp-2 min-h-[2.7em]"
          title={value?.name}
        >
          {value?.name || "Unnamed Product"}
        </Typography>

        <span className="text-sm text-primary font-bold tracking-wider">
          {value?.rtlPrice ? `${formatPrice(value.rtlPrice)}` : "N/A"}
        </span>
      </div>
    </Paper>
  );
};

export default ProdWidget;
